import React from 'react';
import './Navbar.css'

function Navbar() {
    return (
        <div className="navbar">Search with Mario :)</div>
    );
}

export default Navbar;
